import { defineStore } from 'pinia'

export const useIcCardCodeStore = defineStore('icCarCode', {
  state: () => ({
    icCardCodeReader: null // 全局监听ic卡输入
  })
})
